module.exports = __webpack_public_path__ + "static/img/icon-pin.8082230e.svg";